import {
  IconButton,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import CustomTableBody from "../../../utilis/component/CustomTableBody";
import moment from "moment";
import type { PatientAllDocumentsItem } from "./types";

export const VIEW_DETAILS_TABLE_HEADING = [
  "SL NO.",
  "REGISTRATION DATE",
  "EMR NO/REG NO",
  "DOCTOR",
  "DEPARTMENT",
  "ACTIONS",
];

export const DOCUMENTS_SECTION_HEADING = [
  "SL NO.",
  "DOCUMENT NAME",
  "UPLOADED DATE",
  // "ENCOUNTER",
  "VIEW",
];

export function splitPatientDocumentsPayload(response: unknown): {
  registration: PatientAllDocumentsItem[];
  encounter: PatientAllDocumentsItem[];
} {
  if (response == null || typeof response !== "object") {
    return { registration: [], encounter: [] };
  }
  const r = response as Record<string, unknown>;
  return {
    registration: Array.isArray(r.registrationDocuments)
      ? (r.registrationDocuments as PatientAllDocumentsItem[])
      : [],
    encounter: Array.isArray(r.encounterDocuments)
      ? (r.encounterDocuments as PatientAllDocumentsItem[])
      : [],
  };
}

export function displayDocumentName(doc: PatientAllDocumentsItem): string {
  if (doc.documentName?.trim()) return doc.documentName;
  const seg = doc.filePath?.split("/").pop();
  return seg?.trim() || "—";
}

export function formatEncounterCell(doc: PatientAllDocumentsItem): string {
  const parts = [
    doc.encounterDate?.trim()
      ? moment(doc.encounterDate).format("DD-MM-YYYY HH:mm")
      : null,
  ].filter(Boolean);
  return parts.length ? parts.join(" · ") : "—";
}

export type UploadedDocumentsSectionProps = {
  sectionTitle: string;
  docs: PatientAllDocumentsItem[];
};

export function UploadedDocumentsSection({
  sectionTitle,
  docs,
}: UploadedDocumentsSectionProps) {
  const colCount = DOCUMENTS_SECTION_HEADING.length;
  return (
    <div className="flex flex-col gap-2">
      <Typography variant="subtitle2" fontWeight={600} className="px-1">
        {sectionTitle}
        {docs.length > 0 ? ` (${docs.length})` : ""}
      </Typography>
      <TableContainer component={Paper} variant="outlined">
        <Table size="small" aria-label={sectionTitle}>
          <TableHead>
            <TableRow>
              {DOCUMENTS_SECTION_HEADING.map((title) => (
                <TableCell key={title}>
                  <strong>{title}</strong>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <CustomTableBody
            alert={`No ${sectionTitle.toLowerCase()} documents`}
            dataLoading={false}
            isData={docs.length > 0}
            totalSpan={{ col: colCount, row: 5 }}
          >
            {docs.map((doc, i) => (
              <TableRow
                key={`${sectionTitle}-${doc.id}-${i}`}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell>{i + 1}</TableCell>
                <TableCell>{displayDocumentName(doc)}</TableCell>
                <TableCell>{moment(doc.uploadedDate).format("DD-MM-YYYY hh:mm:ss A") || "—"}</TableCell>
                {/* <TableCell>{formatEncounterCell(doc)}</TableCell> */}
                <TableCell>
                  {doc.url ? (
                    <IconButton
                      size="small"
                      component="a"
                      href={doc.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      color="primary"
                    >
                      <VisibilityIcon fontSize="small" />
                    </IconButton>
                  ) : (
                    <span className="text-gray-400 text-sm">—</span>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </CustomTableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
